var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sortedPayments
    ? _c("div", { staticClass: "table-responsive" }, [
        _c(
          "span",
          {
            staticClass: "sr-only",
            attrs: { "aria-live": "assertive", "aria-atomic": "true" }
          },
          [_vm._v("\n    " + _vm._s(_vm.srSortedBy) + "\n  ")]
        ),
        _vm._v(" "),
        _c("table", { staticClass: "table tablerow payments-table sortable" }, [
          _c("caption", [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "pull-right" }, [
              _vm._v(_vm._s(_vm.$t("Sort.Instructions")))
            ])
          ]),
          _vm._v(" "),
          _c("thead", [
            _vm.isHistory
              ? _c("tr", [
                  _c("th", { staticClass: "w-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link btn-sort",
                        on: {
                          click: function($event) {
                            _vm.sortedPayments = _vm.sort(
                              "paymentDate",
                              _vm.payments
                            )
                          }
                        }
                      },
                      [
                        _c("sortable-header-button-content", {
                          attrs: {
                            title: "Payments.PaymentDate",
                            sortedBy: _vm.sortedBy,
                            sortProperty: "paymentDate",
                            sortedAsc: _vm.sortedAsc
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link btn-sort",
                        on: {
                          click: function($event) {
                            _vm.sortedPayments = _vm.sort(
                              "target",
                              _vm.payments
                            )
                          }
                        }
                      },
                      [
                        _c("sortable-header-button-content", {
                          attrs: {
                            title: "AidTargetNumber",
                            sortedBy: _vm.sortedBy,
                            sortProperty: "target",
                            sortedAsc: _vm.sortedAsc
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-40" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link btn-sort right",
                        on: {
                          click: function($event) {
                            _vm.sortedPayments = _vm.sort(
                              "amount",
                              _vm.payments
                            )
                          }
                        }
                      },
                      [
                        _c("sortable-header-button-content", {
                          attrs: {
                            title: "Payments.PaidAmount",
                            sortedBy: _vm.sortedBy,
                            sortProperty: "amount",
                            sortedAsc: _vm.sortedAsc,
                            right: true
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _c("tr", [
                  _c("th", { staticClass: "w-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link btn-sort",
                        on: {
                          click: function($event) {
                            _vm.sortedPayments = _vm.sort(
                              "paymentDate",
                              _vm.payments
                            )
                          }
                        }
                      },
                      [
                        _c("sortable-header-button-content", {
                          attrs: {
                            title: "Payments.PlannedPaymentDate",
                            sortedBy: _vm.sortedBy,
                            sortProperty: "paymentDate",
                            sortedAsc: _vm.sortedAsc
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link btn-sort",
                        on: {
                          click: function($event) {
                            _vm.sortedPayments = _vm.sort(
                              "target",
                              _vm.payments
                            )
                          }
                        }
                      },
                      [
                        _c("sortable-header-button-content", {
                          attrs: {
                            title: "AidTargetNumber",
                            sortedBy: _vm.sortedBy,
                            sortProperty: "target",
                            sortedAsc: _vm.sortedAsc
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-40" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link btn-sort right",
                        on: {
                          click: function($event) {
                            _vm.sortedPayments = _vm.sort(
                              "amount",
                              _vm.payments
                            )
                          }
                        }
                      },
                      [
                        _c("sortable-header-button-content", {
                          attrs: {
                            title: "Payments.SumToBePaid",
                            sortedBy: _vm.sortedBy,
                            sortProperty: "amount",
                            sortedAsc: _vm.sortedAsc,
                            right: true
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.sortedPayments, function(payment) {
              return _c("tr", [
                _vm.isHistory
                  ? _c("td", [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("formatDate")(payment.dateLocal, true))
                        )
                      ])
                    ])
                  : _c("td", [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatDate")(payment.paymentDateLocal, true)
                          )
                        )
                      ])
                    ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", [_vm._v(_vm._s(payment.aidTargetNumber))])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "right" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm._f("formatNumber")(payment.amount)) + " €"
                    )
                  ])
                ])
              ])
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }